import React from 'react';
import {
  Cell, Legend, Pie, PieChart, ResponsiveContainer,
} from 'recharts';
import useManagedAccountPageEventLogger
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/managedAccountPage.eventLogging';

export default function ManagedAccountPortfolioPieChart({ allocationModelClassifications, tickerClassifications, isSimple = false }) {
  const { logPortfolioPieChart, logPortfolioAllocationPieChart } = useManagedAccountPageEventLogger();

  function handlePortfolioChartClick(_, index) {
    logPortfolioPieChart('Sector', {
      name: tickerClassifications[index].name,
    });
  }

  function handleLegendClick(_, index) {
    logPortfolioPieChart('Legend', {
      name: allocationModelClassifications[index].type,
    });
  }

  function handleAllocationChartClick(_, index) {
    logPortfolioAllocationPieChart('Sector', {
      name: allocationModelClassifications[index].type,
    });
  }

  let PieChartComponent = (
    <Pie
      data={allocationModelClassifications}
      dataKey="value"
      cx="50%"
      cy="50%"
      innerRadius={90}
      outerRadius={125}
      legendType="circle"
      startAngle={90}
      endAngle={450}
      strokeWidth={0}
      onClick={handleAllocationChartClick}
    >
      {allocationModelClassifications.map((entry) => <>
        <Cell key={entry.name} fill={entry.color} />
      </>)}
    </Pie>
  );
  if (!isSimple) {
    PieChartComponent = (
      <>
        <Pie
          data={allocationModelClassifications}
          dataKey="value"
          cx="50%"
          cy="50%"
          innerRadius={70}
          outerRadius={75}
          legendType="plainline"
          startAngle={90}
          endAngle={450}
          strokeWidth={2}
          onClick={handleAllocationChartClick}
        >
          {allocationModelClassifications.map((entry) => <>
            <Cell key={entry.name} fill={entry.color} />
          </>)}
        </Pie>
        <Pie
          data={tickerClassifications}
          dataKey="value"
          cx="50%"
          cy="50%"
          innerRadius={90}
          outerRadius={125}
          legendType="none"
          startAngle={90}
          endAngle={450}
          strokeWidth={0}
          onClick={handlePortfolioChartClick}
        >
          {tickerClassifications.map((entry) => <>
            <Cell key={entry.name} fill={entry.color} />
          </>)}
        </Pie>
      </>
    );
  }

  return <>
    <ResponsiveContainer aspect={1}>
      <PieChart>
        { PieChartComponent}
        <Legend
          wrapperStyle={{ fontSize: 12 }}
          align="center"
          verticalAlign="middle"
          layout="vertical"
          itemSorter={'dataKey'}
          onClick={handleLegendClick}
        />
      </PieChart>
    </ResponsiveContainer>

  </>;
}
